// extracted by mini-css-extract-plugin
export default {"table":"Schedule_table__3rymU","table__text":"Schedule_table__text__tpm70"};